module.exports = __webpack_public_path__ + "static/media/tools.ff27b352.svg";